<template>
  <v-app class="boarua-app">
    <div :class="['boarua-shell', { 'sidebar-collapsed': sidebarCollapsed }]">
      <aside :class="['boarua-sidebar d-none d-md-flex', { collapsed: sidebarCollapsed }]">
        <div class="sidebar-head">
          <router-link class="brand" to="/home" :title="sidebarCollapsed ? 'BOARUA' : null">
            <span class="brand-mark"><img src="/img/boarua-icon-concept-v1.png" alt="" /></span>
            <span class="brand-copy">
              <strong>BOARUA</strong>
              <small>Gestão de locais</small>
            </span>
          </router-link>

          <button
            class="sidebar-toggle"
            type="button"
            :title="sidebarCollapsed ? 'Expandir menu' : 'Minimizar menu'"
            @click="toggleDesktopSidebar"
          >
            <v-icon size="20">{{ sidebarCollapsed ? "mdi-menu-open" : "mdi-menu" }}</v-icon>
          </button>
        </div>

        <nav class="sidebar-nav">
          <div v-for="menuGroup in visibleSidebarMenu" :key="menuGroup.name" class="menu-group">
            <p>{{ menuGroup.name }}</p>
            <div v-for="menuOption in menuGroup.children" :key="menuOption.route || menuOption.name" class="nav-entry">
              <button
                :class="['nav-item', { active: isActive(menuOption.route) || isChildActive(menuOption), parent: hasChildren(menuOption), open: isOpen(menuOption), locked: isMenuBlocked(menuOption) }]"
                type="button"
                :title="sidebarCollapsed ? menuOption.name : null"
                @click="goTo(menuOption)"
              >
                <v-icon size="20">{{ menuOption.icon }}</v-icon>
                <span>{{ menuOption.name }}</span>
                <v-icon v-if="isMenuBlocked(menuOption) && !sidebarCollapsed" class="nav-lock" size="15">
                  mdi-lock-outline
                </v-icon>
                <v-icon v-if="hasChildren(menuOption) && !sidebarCollapsed" class="nav-chevron" size="17">
                  {{ isOpen(menuOption) ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
              </button>

              <div v-if="hasChildren(menuOption) && isOpen(menuOption) && !sidebarCollapsed" class="submenu">
                <button
                  v-for="child in menuOption.children"
                  :key="child.route"
                  :class="['submenu-item', { active: isActive(child.route), locked: isMenuBlocked(child) }]"
                  type="button"
                  @click="goTo(child)"
                >
                  <v-icon size="17">{{ child.icon }}</v-icon>
                  <span>{{ child.name }}</span>
                  <v-icon v-if="isMenuBlocked(child)" class="submenu-lock" size="13">mdi-lock-outline</v-icon>
                </button>
              </div>
            </div>
          </div>
        </nav>

        <div :class="['sidebar-plan-footer', sidebarPlanStateClass, { blocked: associationAccessBlocked }]" :title="sidebarCollapsed ? sidebarPlanTooltip : null">
          <div class="sidebar-plan-badge">
            <v-icon size="18">mdi-crown-outline</v-icon>
          </div>
          <div class="sidebar-plan-content">
            <span>Plano atual</span>
            <strong>{{ currentPlanLabel }}</strong>
            <div v-if="sidebarPlanStatusLabel" class="sidebar-plan-status">
              <span>{{ sidebarPlanStatusLabel }}</span>
              <small v-if="sidebarPlanBlockLabel">{{ sidebarPlanBlockLabel }}</small>
            </div>
            <div class="sidebar-usage">
              <span>
                <v-icon size="14">mdi-home-outline</v-icon>
                {{ sidebarUsage.residences }}
              </span>
              <span>
                <v-icon size="14">mdi-storefront-outline</v-icon>
                {{ sidebarUsage.commerces }}
              </span>
            </div>
          </div>
        </div>
      </aside>

      <v-navigation-drawer v-model="drawer" app temporary width="288" class="mobile-drawer">
        <div class="pa-5">
          <router-link class="brand mb-6" to="/home">
            <span class="brand-mark"><img src="/img/boarua-icon-concept-v1.png" alt="" /></span>
            <span>
              <strong>BOARUA</strong>
              <small>Gestão de locais</small>
            </span>
          </router-link>

          <div v-for="menuGroup in visibleSidebarMenu" :key="menuGroup.name" class="menu-group">
            <p>{{ menuGroup.name }}</p>
            <div v-for="menuOption in menuGroup.children" :key="menuOption.route || menuOption.name" class="nav-entry">
              <button
                :class="['nav-item', { active: isActive(menuOption.route) || isChildActive(menuOption), parent: hasChildren(menuOption), open: isOpen(menuOption), locked: isMenuBlocked(menuOption) }]"
                type="button"
                @click="goTo(menuOption)"
              >
                <v-icon size="20">{{ menuOption.icon }}</v-icon>
                <span>{{ menuOption.name }}</span>
                <v-icon v-if="isMenuBlocked(menuOption)" class="nav-lock" size="15">mdi-lock-outline</v-icon>
                <v-icon v-if="hasChildren(menuOption)" class="nav-chevron" size="17">
                  {{ isOpen(menuOption) ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
              </button>

              <div v-if="hasChildren(menuOption) && isOpen(menuOption)" class="submenu">
                <button
                  v-for="child in menuOption.children"
                  :key="child.route"
                  :class="['submenu-item', { active: isActive(child.route), locked: isMenuBlocked(child) }]"
                  type="button"
                  @click="goTo(child)"
                >
                  <v-icon size="17">{{ child.icon }}</v-icon>
                  <span>{{ child.name }}</span>
                  <v-icon v-if="isMenuBlocked(child)" class="submenu-lock" size="13">mdi-lock-outline</v-icon>
                </button>
              </div>
            </div>
          </div>

          <div :class="['sidebar-plan-footer mobile', sidebarPlanStateClass, { blocked: associationAccessBlocked }]">
            <div class="sidebar-plan-badge">
              <v-icon size="18">mdi-crown-outline</v-icon>
            </div>
            <div class="sidebar-plan-content">
              <span>Plano atual</span>
              <strong>{{ currentPlanLabel }}</strong>
              <div v-if="sidebarPlanStatusLabel" class="sidebar-plan-status">
                <span>{{ sidebarPlanStatusLabel }}</span>
                <small v-if="sidebarPlanBlockLabel">{{ sidebarPlanBlockLabel }}</small>
              </div>
              <div class="sidebar-usage">
                <span>
                  <v-icon size="14">mdi-home-outline</v-icon>
                  {{ sidebarUsage.residences }} resid.
                </span>
                <span>
                  <v-icon size="14">mdi-storefront-outline</v-icon>
                  {{ sidebarUsage.commerces }} com.
                </span>
              </div>
            </div>
          </div>
        </div>
      </v-navigation-drawer>

      <main class="boarua-main">
        <header class="boarua-topbar">
          <div class="d-flex align-center">
            <v-btn icon class="d-md-none mr-2" @click="drawer = true">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
            <div class="topbar-title">
              <h1>Bem-vindo, {{ firstName }}</h1>
              <p>{{ routeSubtitle }}</p>
            </div>
          </div>

          <div class="topbar-actions">
            <v-menu
              v-model="notificationsMenu"
              offset-y
              left
              max-width="340"
              min-width="320"
              content-class="notification-popover"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="topbar-icon" v-bind="attrs" v-on="on" @click="refreshNotificationState">
                  <v-icon size="20">mdi-bell-outline</v-icon>
                </v-btn>
              </template>
              <div class="notification-card">
                <div class="notification-head">
                  <div>
                    <strong>Notificações</strong>
                    <span>{{ notificationStatusText }}</span>
                  </div>
                  <v-chip x-small label :color="notificationStatusColor" text-color="white">
                    {{ notificationStatusLabel }}
                  </v-chip>
                </div>

                <div class="notification-list">
                  <div v-for="item in notificationItems" :key="item.title" class="notification-item">
                    <v-icon size="18" color="primary">{{ item.icon }}</v-icon>
                    <div>
                      <strong>{{ item.title }}</strong>
                      <span>{{ item.description }}</span>
                    </div>
                  </div>
                </div>

                <v-btn
                  v-if="notificationPermission !== 'granted'"
                  block
                  depressed
                  color="primary"
                  :loading="requestingNotifications"
                  :disabled="notificationPermission === 'unsupported'"
                  @click="enableNotifications"
                >
                  {{ notificationActionLabel }}
                </v-btn>
              </div>
            </v-menu>
            <v-menu min-width="220" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <button class="user-chip" type="button" v-bind="attrs" v-on="on">
                  <v-avatar size="42">
                    <img :src="avatarUrl" />
                  </v-avatar>
                </button>
              </template>
              <v-list dense>
                <MenuItem
                  v-for="(menuOption, index) in profileMenu"
                  :key="index"
                  :item="menuOption"
                  v-if="!menuOption || !menuOption.children"
                />
                <v-list-item class="user-menu-item logout" @click="logout">
                  <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Sair</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </header>

        <div v-if="associationAccessBlocked && !['/configuracoes/conta', '/configuracoes/planos'].includes($route.path)" class="association-blocked-banner">
          <div class="association-blocked-copy">
            <span class="association-blocked-icon">
              <v-icon size="20">mdi-lock-alert-outline</v-icon>
            </span>
            <div>
              <strong>Associação com plano pendente</strong>
              <p>{{ associationBlockedMessage }}</p>
            </div>
          </div>
          <v-btn depressed color="primary" class="association-blocked-action" @click="goToPlanPayment">
            Regularizar plano
          </v-btn>
        </div>

        <section class="boarua-content">
          <div v-if="associationAccessBlocked && !isCurrentRouteAllowed" class="association-blocked-screen">
            <v-icon size="44">mdi-lock-alert-outline</v-icon>
            <h2>Uso bloqueado até a regularização do plano</h2>
            <p>{{ associationBlockedMessage }}</p>
            <v-btn depressed color="primary" @click="goToPlanPayment">Ir para pagamentos</v-btn>
          </div>
          <router-view v-else />
        </section>
        <PoweredByFooter bottom-nav />
      </main>

      <nav class="mobile-bottom-nav d-md-none" aria-label="Navegação principal mobile">
        <button
          v-for="item in mobileBottomItems"
          :key="item.route"
          :class="['mobile-bottom-item', { active: isActive(item.route), locked: isMenuBlocked(item) }]"
          type="button"
          @click="goTo(item)"
        >
          <v-icon size="21">{{ item.icon }}</v-icon>
          <span>{{ item.name }}</span>
        </button>
        <button class="mobile-bottom-item" type="button" @click="drawer = true">
          <v-icon size="21">mdi-menu</v-icon>
          <span>Mais</span>
        </button>
      </nav>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" bottom right>
        {{ snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Fechar</v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
import router from "../router";
import MenuItem from "@/layouts/components/MenuItem";
import PoweredByFooter from "@/components/PoweredByFooter.vue";
import profileMenu from "@/common/data/profile-menu.data";
import sidebarMenu from "@/common/data/sidebar-menu.data";
import { registerBoaruaPush } from "@/plugins/push-notifications";
import axios from "axios";

const ASSOCIATION_BLOCKED_STORAGE_KEY = "boaruaAssociationAccessBlocked";
const ASSOCIATION_BLOCKED_MESSAGE =
  "A Associação não está em dia com o BOARUA. O uso da plataforma será liberado após a confirmação do pagamento do plano.";

export default {
  name: "PrivateLayout",
  components: { MenuItem, PoweredByFooter },
  data() {
    return {
      drawer: false,
      user: null,
      sidebarMenu,
      profileMenu,
      openMenus: {},
      sidebarCollapsed: localStorage.getItem("boaruaSidebarCollapsed") === "true",
      notificationsMenu: false,
      notificationPermission: typeof Notification !== "undefined" ? Notification.permission : "unsupported",
      requestingNotifications: false,
      sidebarBilling: {
        planKey: "plus",
        accessStatus: null,
        planCharge: null,
        loading: false,
        usage: {
          residences: 0,
          commerces: 0,
        },
      },
      associationAccessBlocked: false,
      associationBlockedCode: "",
      associationBlockedMessage: ASSOCIATION_BLOCKED_MESSAGE,
      snackbar: {
        show: false,
        message: "",
        color: "info",
        timeout: 5000,
      },
    };
  },
  computed: {
    routeTitle() {
      return this.$route.meta.title || this.$route.name || "Visão Geral";
    },
    routeSubtitle() {
      return this.$route.meta.subtitle || "Gerencie seu local com dados em tempo real";
    },
    firstName() {
      const name = this.user && this.user.name ? this.user.name : "Administrador";
      return String(name).split(" ")[0];
    },
    avatarUrl() {
      const name = this.user ? this.user.name : "Usuário BOARUA";
      return `https://ui-avatars.com/api/?background=057a3d&color=fff&name=${encodeURIComponent(name)}`;
    },
    notificationStatusLabel() {
      if (this.notificationPermission === "granted") return "Ativas";
      if (this.notificationPermission === "denied") return "Bloqueadas";
      if (this.notificationPermission === "unsupported") return "Indisponível";
      return "Pendente";
    },
    notificationStatusColor() {
      if (this.notificationPermission === "granted") return "primary";
      if (this.notificationPermission === "denied") return "error";
      return "grey";
    },
    notificationStatusText() {
      if (this.notificationPermission === "granted") return "Você receberá avisos importantes do local.";
      if (this.notificationPermission === "denied") return "As notificações estão bloqueadas no navegador.";
      if (this.notificationPermission === "unsupported") return "Este navegador não suporta notificações.";
      return "Ative para receber alertas, vencimentos e avisos.";
    },
    notificationItems() {
      return [
        { icon: "mdi-shield-alert-outline", title: "Alertas de segurança", description: "Chamados urgentes e movimentações críticas." },
        { icon: "mdi-barcode", title: "Cobranças", description: "Faturas disponíveis, vencimentos e pendências." },
        { icon: "mdi-account-group-outline", title: "Assembleias", description: "Novas pautas, datas e confirmações de presença." },
      ];
    },
    notificationActionLabel() {
      if (this.notificationPermission === "denied") return "Como desbloquear";
      if (this.notificationPermission === "unsupported") return "Indisponível";
      return "Ativar notificações";
    },
    currentPlanLabel() {
      const labels = {
        basic: "Basic",
        plus: "Plus",
        pro: "Pro",
        premium: "Premium",
        enterprise: "Enterprise",
        pending: "Pendente",
      };
      return labels[this.sidebarBilling.planKey] || "Plus";
    },
    sidebarUsage() {
      return this.sidebarBilling.usage || { residences: 0, commerces: 0 };
    },
    sidebarPlanAccessStatus() {
      return this.sidebarBilling.accessStatus || {};
    },
    sidebarPlanStateClass() {
      const state = String(this.sidebarPlanAccessStatus.state || "");
      if (state === "past_due_grace") return "overdue";
      return "";
    },
    sidebarPlanStatusLabel() {
      const status = this.sidebarPlanAccessStatus;
      const charge = this.sidebarBilling.planCharge || {};
      const state = String(status.state || "");
      const reason = String(status.reason || "");
      const chargeStatus = String(charge.status || "");

      if (chargeStatus === "overdue") return "Vencido";
      if (state === "past_due_grace" || reason === "payment_overdue_grace") return "Vencido";
      if (this.associationAccessBlocked) return "Bloqueado";
      if (chargeStatus === "pending") return "Pendente";
      if (state === "pending_payment" || reason === "pending_payment") return "Pendente";
      return "";
    },
    sidebarPlanBlockLabel() {
      const status = this.sidebarPlanAccessStatus;
      const charge = this.sidebarBilling.planCharge || {};
      const state = String(status.state || "");
      const reason = String(status.reason || "");

      if (String(charge.status || "") === "overdue") {
        const fallbackBlockDate = this.datePlusDays(charge.due_date, 14);
        const blockDate = status.grace_until || fallbackBlockDate;
        return blockDate ? `Bloqueia em ${this.formatShortDate(blockDate)}` : "";
      }

      if (state === "past_due_grace" || reason === "payment_overdue_grace") {
        const blockDate = status.grace_until;
        return blockDate ? `Bloqueia em ${this.formatShortDate(blockDate)}` : "";
      }

      if (this.associationAccessBlocked && status.blocked_at) {
        return `Desde ${this.formatShortDate(status.blocked_at)}`;
      }

      return "";
    },
    sidebarPlanTooltip() {
      const status = [this.currentPlanLabel, this.sidebarPlanStatusLabel, this.sidebarPlanBlockLabel].filter(Boolean).join(" · ");

      if (status) {
        return `${status} · ${this.sidebarUsage.residences} residências · ${this.sidebarUsage.commerces} comércios`;
      }

      return `${this.currentPlanLabel} · ${this.sidebarUsage.residences} residências · ${this.sidebarUsage.commerces} comércios`;
    },
    blockedAllowedRoutes() {
      return ["/configuracoes/conta", "/configuracoes/planos"];
    },
    isCurrentRouteAllowed() {
      return this.isRouteAllowedWhenBlocked(this.$route.path);
    },
    visibleSidebarMenu() {
      if (![5, 6].includes(Number(this.user && this.user.type))) {
        return this.sidebarMenu;
      }

      if (Number(this.user && this.user.type) === 6) {
        return [
          {
            name: "Operação",
            children: [
              {
                name: "Portaria",
                icon: "mdi-gate",
                route: "/portaria/autorizacoes",
                path: null,
                children: [
                  { name: "Autorizações", icon: "mdi-account-check-outline", route: "/portaria/autorizacoes", path: null },
                  { name: "Encomendas", icon: "mdi-package-variant-closed", route: "/portaria/encomendas", path: null },
                  { name: "Portarias", icon: "mdi-gate", route: "/portaria/portarias", path: null },
                ],
              },
            ],
          },
        ];
      }

      return [
        {
          name: "Operação",
          children: [
            {
              name: "Segurança",
              icon: "mdi-shield-alert-outline",
              route: "/seguranca/central",
              path: null,
              children: [
                { name: "Central", icon: "mdi-shield-home-outline", route: "/seguranca/central", path: null },
                { name: "Território", icon: "mdi-map-marker-path", route: "/seguranca/territorio", path: null },
                { name: "Equipes", icon: "mdi-account-hard-hat-outline", route: "/seguranca/equipes", path: null },
              ],
            },
          ],
        },
      ];
    },
    mobileBottomItems() {
      const preferredRoutes = ["/home", "/operacao/residencias", "/operacao/comercio", "/configuracoes/conta"];
      return preferredRoutes
        .map((route) => this.findVisibleMenuItemByRoute(route))
        .filter(Boolean)
        .slice(0, 4)
        .map((item) => {
          if (item.route === "/operacao/residencias") return Object.assign({}, item, { name: "Moradias" });
          if (item.route === "/configuracoes/conta") return Object.assign({}, item, { name: "Conta" });
          if (item.route === "/home") return Object.assign({}, item, { name: "Início" });
          return item;
        });
    },
  },
  watch: {
    "$route.path"(path) {
      if (this.associationAccessBlocked && !this.isRouteAllowedWhenBlocked(path)) {
        this.goToPlanPayment();
      }
    },
  },
  created() {
    this.user = this.$root.user.data || this.$root.user;
    if (typeof window !== "undefined") {
      window.addEventListener("boarua-api-error", this.handleApiError);
    }
    this.restoreAssociationBlockedState();
    if (this.$root.$eventHub) {
      this.$root.$eventHub.$on("logout", () => this.logout());
      this.$root.$eventHub.$on("toggle-sidebar", this.toggleSidebar);
    }
    this.refreshNotificationState();
    this.refreshAssociationAccessState();
    this.loadSidebarBilling();
    if (this.notificationPermission === "granted") {
      this.registerNotifications({ requestPermission: false });
    }
  },
  destroyed() {
    if (typeof window !== "undefined") {
      window.removeEventListener("boarua-api-error", this.handleApiError);
    }
    if (this.$root.$eventHub) {
      this.$root.$eventHub.$off("logout");
      this.$root.$eventHub.$off("toggle-sidebar", this.toggleSidebar);
    }
  },
  methods: {
    refreshNotificationState() {
      this.notificationPermission = typeof Notification !== "undefined" ? Notification.permission : "unsupported";
    },
    async enableNotifications() {
      this.refreshNotificationState();

      if (this.notificationPermission === "unsupported") {
        this.notify("Este navegador não suporta notificações.", "warning");
        return;
      }

      if (this.notificationPermission === "denied") {
        this.notify("As notificações estão bloqueadas. Libere as permissões deste site no navegador e recarregue a página.", "warning", 8000);
        return;
      }

      this.requestingNotifications = true;
      try {
        const registered = await this.registerNotifications({ requestPermission: true });
        this.refreshNotificationState();
        if (registered) {
          this.notify("Notificações ativadas com sucesso.", "success");
        } else if (this.notificationPermission !== "granted") {
          this.notify("Permissão de notificação não concedida.", "warning");
        }
      } catch (error) {
        console.error("[BOARUA] Falha ao ativar notificacoes no backoffice", error);
        this.notify("Não foi possível ativar as notificações agora.", "error");
      } finally {
        this.requestingNotifications = false;
      }
    },
    async loadSidebarBilling() {
      if (this.sidebarBilling.loading) return;
      this.sidebarBilling.loading = true;

      try {
        const [associationResponse, unitsResponse, planChargeResponse] = await Promise.all([
          axios.get("/associations/current/profile"),
          axios.get("/member-units", { params: { limit: 1000, search: JSON.stringify({ status: "active" }) } }),
          axios.get("/boarua-plan-charges/current").catch(() => null),
        ]);
        const association = associationResponse.data.content || {};
        const units = (unitsResponse.data.content && unitsResponse.data.content.data) || unitsResponse.data.content || [];
        const planChargeContent = (planChargeResponse && planChargeResponse.data && planChargeResponse.data.content) || {};

        this.sidebarBilling.planKey = association.boarua_plan_key || "plus";
        this.sidebarBilling.accessStatus = association.access_status || null;
        this.sidebarBilling.planCharge = planChargeContent.charge || null;
        this.sidebarBilling.usage = units.reduce(
          (counts, unit) => {
            if (this.isCommerceUnit(unit)) counts.commerces += 1;
            else counts.residences += 1;
            return counts;
          },
          { residences: 0, commerces: 0 }
        );
      } catch (error) {
        const apiError = this.apiErrorFromPayload(error);
        if (apiError && apiError.code === "ASSOCIATION_ACCESS_BLOCKED") {
          this.applyAssociationBlockedState(apiError, { notify: false });
        }
        this.sidebarBilling.usage = { residences: 0, commerces: 0 };
      } finally {
        this.sidebarBilling.loading = false;
      }
    },
    async refreshAssociationAccessState() {
      try {
        const response = await axios.get("/associations/current/profile");
        const association = response.data.content || null;
        const accessStatus = association && association.access_status;
        this.sidebarBilling.accessStatus = accessStatus || null;

        if (accessStatus && accessStatus.allowed === false) {
          this.applyAssociationBlockedState(
            {
              code: "ASSOCIATION_ACCESS_BLOCKED",
              message: ASSOCIATION_BLOCKED_MESSAGE,
              reason: accessStatus.reason,
              state: accessStatus.state,
            },
            { notify: false }
          );
          return;
        }

        if (accessStatus && accessStatus.allowed === true) {
          this.clearAssociationBlockedState();
        }
      } catch (error) {
        const apiError = this.apiErrorFromPayload(error);
        if (apiError && apiError.code === "ASSOCIATION_ACCESS_BLOCKED") {
          this.applyAssociationBlockedState(apiError, { notify: false });
        }
      }
    },
    apiErrorFromPayload(payload = {}) {
      return (
        (payload.content && payload.content.error) ||
        payload.error ||
        (payload.response && payload.response.data && payload.response.data.content && payload.response.data.content.error) ||
        (payload.response && payload.response.data && payload.response.data.error) ||
        null
      );
    },
    isCommerceUnit(unit) {
      const type = String(unit && (unit.address_type || unit.type || unit.category || unit.unit_type || ""))
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      return ["commerce", "commercial", "comercio", "comercial", "store", "business"].includes(type);
    },
    handleApiError(event) {
      const detail = (event && event.detail) || {};
      if (detail.code !== "ASSOCIATION_ACCESS_BLOCKED") return;

      this.applyAssociationBlockedState(detail);
    },
    restoreAssociationBlockedState() {
      if (typeof window === "undefined") return;
      const stored = localStorage.getItem(ASSOCIATION_BLOCKED_STORAGE_KEY);
      if (!stored) return;

      try {
        const detail = JSON.parse(stored);
        if (detail && detail.code === "ASSOCIATION_ACCESS_BLOCKED") {
          this.applyAssociationBlockedState(detail, { notify: false });
        }
      } catch (error) {
        localStorage.removeItem(ASSOCIATION_BLOCKED_STORAGE_KEY);
      }
    },
    applyAssociationBlockedState(detail = {}, options = {}) {
      this.associationAccessBlocked = true;
      this.associationBlockedCode = detail.code || "ASSOCIATION_ACCESS_BLOCKED";
      this.associationBlockedMessage = this.associationBlockedCode === "ASSOCIATION_ACCESS_BLOCKED"
        ? ASSOCIATION_BLOCKED_MESSAGE
        : detail.message || ASSOCIATION_BLOCKED_MESSAGE;
      this.sidebarBilling.planKey = "pending";
      this.sidebarBilling.accessStatus = {
        state: detail.state || "blocked",
        reason: detail.reason || "blocked",
        blocked_at: detail.blockedAt || new Date().toISOString(),
      };

      localStorage.setItem(
        ASSOCIATION_BLOCKED_STORAGE_KEY,
        JSON.stringify({
          code: this.associationBlockedCode,
          message: this.associationBlockedMessage,
          blockedAt: detail.blockedAt || new Date().toISOString(),
        })
      );

      if (options.notify !== false) {
        this.notify(this.associationBlockedMessage, "warning", 9000);
      }

      if (!this.isRouteAllowedWhenBlocked(this.$route.path)) {
        this.$router.push("/configuracoes/pagamentos").catch(() => {});
      }
    },
    clearAssociationBlockedState() {
      this.associationAccessBlocked = false;
      this.associationBlockedCode = "";
      this.associationBlockedMessage = ASSOCIATION_BLOCKED_MESSAGE;

      if (typeof window !== "undefined") {
        localStorage.removeItem(ASSOCIATION_BLOCKED_STORAGE_KEY);
      }
    },
    formatShortDate(value) {
      if (!value) return "";
      const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) return `${match[3]}/${match[2]}`;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
    },
    datePlusDays(value, days) {
      const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return "";
      const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
      date.setDate(date.getDate() + days);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    isRouteAllowedWhenBlocked(route) {
      if (!this.associationAccessBlocked) return true;
      if (!route) return false;
      return this.blockedAllowedRoutes.some((allowedRoute) => {
        return route === allowedRoute || route.indexOf(`${allowedRoute}/`) === 0;
      });
    },
    isMenuBlocked(item) {
      if (!this.associationAccessBlocked || !item) return false;
      if (this.hasChildren(item)) {
        return !(item.children || []).some((child) => this.isRouteAllowedWhenBlocked(child.route));
      }
      return !this.isRouteAllowedWhenBlocked(item.route);
    },
    goToPlanPayment() {
      if (this.$route.path !== "/configuracoes/planos") {
        this.$router.push("/configuracoes/planos").catch(() => {});
      }
      this.drawer = false;
    },
    hasChildren(item) {
      return item && item.children && item.children.length;
    },
    isOpen(item) {
      if (!item) return false;
      if (Object.prototype.hasOwnProperty.call(this.openMenus, item.name)) {
        return !!this.openMenus[item.name];
      }
      return !!((item.children || []).some((child) => this.isActive(child.route)));
    },
    isChildActive(item) {
      return !!(item && item.children && item.children.some((child) => this.isActive(child.route)));
    },
    isActive(route) {
      if (!route) return false;
      const path = this.$route.path;
      if (path === route) return true;
      if (path.indexOf(`${route}/`) !== 0) return false;

      return !this.menuRoutes().some((candidate) => {
        if (!candidate || candidate === route || candidate.length <= route.length) return false;
        return path === candidate || path.indexOf(`${candidate}/`) === 0;
      });
    },
    menuRoutes() {
      const routes = [];
      const append = (items = []) => {
        items.forEach((item) => {
          if (item.route) routes.push(item.route);
          if (item.children) append(item.children);
        });
      };

      append(this.visibleSidebarMenu.flatMap((group) => group.children || []));
      return routes;
    },
    findVisibleMenuItemByRoute(route) {
      let match = null;
      const walk = (items = []) => {
        for (const item of items) {
          if (item.route === route) {
            match = item;
            return;
          }
          if (item.children) walk(item.children);
          if (match) return;
        }
      };

      walk(this.visibleSidebarMenu.flatMap((group) => group.children || []));
      return match;
    },
    goTo(item) {
      if (item.event === "logout") {
        this.logout();
        return;
      }
      if (this.associationAccessBlocked && this.isMenuBlocked(item)) {
        return;
      }
      if (this.hasChildren(item)) {
        if (this.sidebarCollapsed) {
          this.sidebarCollapsed = false;
          localStorage.setItem("boaruaSidebarCollapsed", "false");
          this.$set(this.openMenus, item.name, true);
          return;
        }
        this.$set(this.openMenus, item.name, !this.isOpen(item));
        return;
      }
      if (item.route && this.$route.path !== item.route) {
        this.$router.push(item.route);
      }
      this.drawer = false;
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
    },
    toggleDesktopSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      localStorage.setItem("boaruaSidebarCollapsed", String(this.sidebarCollapsed));
      window.dispatchEvent(new CustomEvent("boarua:layout-resize"));
    },
    async logout() {
      localStorage.clear();
      router.push("/login");
    },
    notify(message, color = "info", timeout = 5000) {
      this.snackbar = {
        show: true,
        message,
        color,
        timeout,
      };
    },
    async registerNotifications(options = {}) {
      try {
        return await registerBoaruaPush(options);
      } catch (error) {
        console.error("[BOARUA] Falha ao registrar notificacoes no backoffice", error);
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.boarua-app {
  background: #d8d8d8;
}

.boarua-shell {
  --boarua-sidebar-width: 270px;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 0;
  overflow: hidden;
  background: #f1f1ef;
  border-radius: 0;
  box-shadow: 0 28px 70px rgba(20, 30, 24, 0.08);
}

.boarua-shell.sidebar-collapsed {
  --boarua-sidebar-width: 72px;
}

.boarua-sidebar {
  width: 270px;
  flex: 0 0 270px;
  height: 100vh;
  min-height: 100vh;
  padding: 28px 28px 24px;
  flex-direction: column;
  background: #ffffff;
  border: 0;
  border-right: 1px solid #ededea;
  border-radius: 0;
  overflow: hidden;
  position: sticky;
  top: 0;
  transition: width 180ms ease, flex-basis 180ms ease, padding 180ms ease;

  &.collapsed {
    width: 72px;
    flex-basis: 72px;
    padding: 22px 10px;

    .sidebar-head {
      flex-direction: column;
      align-items: center;
      gap: 14px;
    }

    .brand {
      justify-content: center;
    }

    .brand-copy,
    .menu-group p,
    .nav-item span,
    .sidebar-plan-content {
      display: none;
    }

    .sidebar-nav {
      margin-top: 34px;
    }

    .menu-group {
      margin-bottom: 18px;
    }

    .nav-item {
      width: 44px;
      height: 44px;
      min-height: 44px;
      margin: 0 auto 10px;
      padding: 0;
      justify-content: center;
      border-radius: 14px;
    }

    .nav-item.parent.open {
      margin-bottom: 10px;
    }

    .sidebar-plan-footer {
      width: 44px;
      min-height: 44px;
      margin: 8px auto 0;
      padding: 0;
      justify-content: center;
      border-radius: 14px;
    }
  }
}

.sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #111827;
  text-decoration: none;

  strong,
  small {
    display: block;
    line-height: 1.2;
  }

  strong {
    color: #141414;
    font-size: 18px;
    font-weight: 700;
  }

  small {
    color: #6b7280;
    font-size: 11px;
  }
}

.brand-copy {
  white-space: nowrap;
}

.brand-mark {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: none;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.sidebar-toggle {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #111111;
  background: #f6f7f5;
  border: 1px solid #e1e4df;
  border-radius: 12px;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, color 160ms ease;

  .v-icon {
    color: currentColor;
  }

  &:hover {
    color: #ffffff;
    background: #004f45;
    border-color: #004f45;
  }
}

.sidebar-nav {
  flex: 1;
  margin-top: 30px;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cfd9d3 transparent;
}

.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: #cfd9d3;
  border-radius: 999px;
}

.sidebar-plan-footer {
  margin-top: 16px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #dce9e2;
  border-radius: 8px;
  background: #f6fbf8;
  box-shadow: 0 10px 28px rgba(0, 79, 69, 0.06);

  &.mobile {
    margin-top: 18px;
  }

  &.blocked,
  &.overdue {
    border-color: #fed7aa;
    background: #fff7ed;
    box-shadow: 0 10px 28px rgba(194, 65, 12, 0.08);

    .sidebar-plan-badge {
      background: #ffedd5;
      color: #c2410c;
    }

    .sidebar-plan-content {
      > span,
      .sidebar-usage span {
        color: #9a3412;
      }

      strong {
        color: #7c2d12;
      }

      .sidebar-plan-status {
        span {
          color: #9a3412;
          background: #ffedd5;
        }

        small {
          color: #9a3412;
        }
      }

      .v-icon {
        color: #c2410c;
      }
    }
  }
}

.sidebar-plan-badge {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #e8f6ee;
  color: #057a3d;

  .v-icon {
    color: currentColor;
  }
}

.sidebar-plan-content {
  min-width: 0;
  flex: 1;

  span,
  strong {
    display: block;
  }

  > span {
    color: #65736b;
    font-size: 10px;
    font-weight: 800;
    line-height: 1.2;
    text-transform: uppercase;
  }

  strong {
    margin-top: 2px;
    color: #10223f;
    font-size: 14px;
    font-weight: 900;
    line-height: 1.15;
  }
}

.sidebar-plan-status {
  min-width: 0;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;

  span {
    width: max-content;
    max-width: 100%;
    padding: 3px 6px;
    border-radius: 999px;
    color: #04783b;
    background: #e8f6ee;
    font-size: 9px;
    font-weight: 900;
    line-height: 1;
    text-transform: uppercase;
    white-space: nowrap;
  }

  small {
    min-width: 0;
    display: block;
    color: #65736b;
    font-size: 10px;
    font-weight: 800;
    line-height: 1.15;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.sidebar-usage {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  span {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    color: #4f6258;
    font-size: 11px;
    font-weight: 800;
    line-height: 1;
  }

  .v-icon {
    color: #057a3d;
  }
}

.menu-group {
  margin-bottom: 42px;

  p {
    margin: 0 0 18px;
    padding: 0;
    color: #111111;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
  }
}

.nav-item {
  width: 100%;
  min-height: 38px;
  margin-bottom: 8px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #151b18;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;

  .v-icon {
    color: #1e2925;
  }

  &.active,
  &:hover {
    color: #ffffff;
    background: #004f45;
    box-shadow: none;

    .v-icon {
      color: #ffffff;
    }
  }

  &.parent {
    justify-content: flex-start;
  }

  &.parent.open {
    margin-bottom: 4px;
  }
}

.nav-chevron {
  margin-left: auto;
}

.nav-lock,
.submenu-lock {
  margin-left: auto;
  color: currentColor !important;
  opacity: 0.75;
}

.nav-item.locked,
.submenu-item.locked {
  color: #6f746f;
  background: transparent;
  border-color: transparent;
  cursor: not-allowed;
  opacity: 0.78;

  .v-icon {
    color: currentColor;
  }

  &:hover {
    color: #6f746f;
    background: transparent;
    box-shadow: none;

    .v-icon {
      color: currentColor;
    }
  }
}

.submenu {
  margin: -2px 0 8px 15px;
  padding: 4px 0 4px 13px;
  border-left: 1px solid #dfe6e1;
}

.submenu-item {
  width: 100%;
  min-height: 32px;
  margin-bottom: 3px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4f5d56;
  background: transparent;
  border: 0;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;

  .v-icon {
    color: #64736b;
  }

  &.active,
  &:hover {
    color: #057a3d;
    background: #e9f5ef;

    .v-icon {
      color: #057a3d;
    }
  }
}

.boarua-main {
  flex: 1;
  min-width: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f1f1ef;
  border: 0;
  border-radius: 0;
}

.boarua-topbar {
  min-height: 72px;
  margin: 0 34px;
  padding: 10px 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  background: transparent;
  border-bottom: 1px solid #cfcfca;
}

.boarua-topbar h1 {
  margin: 0;
  color: #111111;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.boarua-topbar p {
  margin: 3px 0 0;
  color: #555a56;
  font-size: 11px;
}

.association-blocked-banner {
  margin: 18px 34px 0;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border: 1px solid #fdba74;
  border-radius: 8px;
  background: #fff7ed;
}

.association-blocked-copy {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 12px;

  strong,
  p {
    display: block;
  }

  strong {
    color: #7c2d12;
    font-size: 14px;
    font-weight: 900;
    line-height: 1.25;
  }

  p {
    margin: 4px 0 0;
    color: #9a3412;
    font-size: 12px;
    line-height: 1.4;
  }
}

.association-blocked-icon {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #c2410c;
  background: #ffedd5;
  border-radius: 8px;

  .v-icon {
    color: currentColor;
  }
}

.association-blocked-action {
  flex: 0 0 auto;
}

.association-blocked-screen {
  min-height: 420px;
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
  border: 1px solid #fdba74;
  border-radius: 8px;
  background: #fffaf2;

  .v-icon {
    color: #c2410c;
  }

  h2 {
    margin: 4px 0 0;
    color: #111827;
    font-size: 22px;
    font-weight: 900;
  }

  p {
    max-width: 560px;
    margin: 0 0 8px;
    color: #6b4b32;
    font-size: 14px;
    line-height: 1.5;
  }
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.topbar-icon {
  width: 38px;
  height: 38px;
  color: #111111;
  background: transparent;
  border: 1px solid #111111;
  border-radius: 50%;
}

.notification-card {
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e3e8e4;
  border-radius: 16px;
  box-shadow: 0 22px 60px rgba(17, 24, 39, 0.14);
}

.notification-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;

  strong,
  span {
    display: block;
  }

  strong {
    color: #111827;
    font-size: 16px;
    font-weight: 800;
  }

  span {
    margin-top: 3px;
    color: #66736b;
    font-size: 12px;
    line-height: 1.35;
  }
}

.notification-list {
  margin: 14px 0;
  display: grid;
  gap: 8px;
}

.notification-item {
  padding: 10px;
  display: flex;
  gap: 10px;
  border: 1px solid #eef2ef;
  border-radius: 12px;
  background: #fbfcfb;

  strong,
  span {
    display: block;
  }

  strong {
    color: #111827;
    font-size: 13px;
  }

  span {
    margin-top: 2px;
    color: #66736b;
    font-size: 11px;
    line-height: 1.35;
  }
}

.user-chip {
  min-height: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}

.user-menu-item {
  cursor: pointer;
}

.user-menu-item.logout {
  color: #b42318;

  .v-icon {
    color: currentColor;
  }
}

.boarua-content {
  padding: 24px 34px 34px;
}

.mobile-drawer {
  background: #ffffff;
}

.mobile-bottom-nav {
  position: fixed;
  right: 12px;
  bottom: 12px;
  left: 12px;
  z-index: 90;
  min-height: 64px;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 4px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #dce6df;
  border-radius: 18px;
  box-shadow: 0 18px 42px rgba(16, 34, 63, 0.18);
  backdrop-filter: blur(10px);
}

.mobile-bottom-item {
  min-width: 0;
  min-height: 48px;
  padding: 6px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #60706a;
  background: transparent;
  border: 0;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.1;
  cursor: pointer;

  .v-icon {
    color: currentColor;
  }

  span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.active {
    color: #057a3d;
    background: #e8f6ee;
  }

  &.locked {
    color: #a8aeaa;
  }
}

@media (max-width: 959px) {
  .boarua-shell {
    --boarua-sidebar-width: 0px;
    width: 100%;
    min-height: 100vh;
    margin: 0;
    padding: 0;
    border-radius: 0;
  }

  .boarua-main {
    min-height: 100vh;
    border: 0;
    border-radius: 0;
  }

  .boarua-content {
    padding: 16px 16px 96px;
  }

  .association-blocked-banner {
    margin: 14px 16px 0;
    align-items: stretch;
    flex-direction: column;
  }

  .association-blocked-action {
    width: 100%;
  }

  .boarua-topbar {
    min-height: 72px;
    margin: 0;
    padding: 12px 18px;
    background: #ffffff;
    border-bottom: 1px solid #e5e7eb;
    box-shadow: 0 8px 24px rgba(17, 24, 39, 0.04);
  }

  .topbar-title,
  .topbar-icon {
    display: none;
  }

  .topbar-actions {
    margin-left: auto;
  }

  .user-chip .v-avatar {
    width: 46px !important;
    height: 46px !important;
  }
}
</style>
